/* Progressive navigation enhancement. The existing theme owns the mobile drawer. */
(() => {
  const navigation = document.querySelector('.lc');
  if (navigation) {
    const disclosures = [...navigation.querySelectorAll('.lc__disclosure')];
    const categories = [...navigation.querySelectorAll('[data-lc-category]')];
    const panels = [...navigation.querySelectorAll('.lc__category-panel')];
    const close = () => { for (const disclosure of disclosures) disclosure.open = false; };
    /** @param {HTMLAnchorElement} selected */
    const select = (selected) => {
      for (const category of categories) category.setAttribute('aria-pressed', String(category === selected));
      for (const panel of panels) panel.hidden = panel.id !== selected.getAttribute('aria-controls');
    };
    for (const category of categories) {
      category.setAttribute('role', 'button');
      category.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
        event.preventDefault();
        select(category);
        const panel = document.getElementById(category.getAttribute('aria-controls'));
        navigation.querySelector('[data-lc-status]').textContent = panel?.querySelector('.lc__title')?.textContent || '';
      });
      category.addEventListener('keydown', (event) => {
        if (event.key !== ' ') return;
        event.preventDefault();
        category.click();
      });
    }
    if (categories[0]) select(categories[0]);
    navigation.classList.add('lc--enhanced');
    for (const disclosure of disclosures) {
      disclosure.addEventListener('toggle', () => {
        if (!disclosure.open) return;
        for (const other of disclosures) if (other !== disclosure) other.open = false;
      });
    }
    document.addEventListener('click', (event) => { if (!navigation.contains(event.target)) close(); });
    navigation.addEventListener('focusout', (event) => { if (!navigation.contains(event.relatedTarget)) close(); });
    navigation.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = disclosures.find(disclosure => disclosure.open);
      if (!open) return;
      close();
      open.querySelector('summary').focus();
      event.preventDefault();
    });
    const desktop = window.matchMedia?.('(min-width: 1101px)');
    desktop?.addEventListener('change', close);
  }
  /** @param {string} value */
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  for (const directory of document.querySelectorAll('[data-lc-brands]')) {
    const input = directory.querySelector('[data-lc-brand-search]');
    const brands = [...directory.querySelectorAll('[data-lc-brand]')];
    if (!input) continue;
    input.addEventListener('input', () => {
      const query = normalize(input.value);
      let matches = 0;
      for (const brand of brands) {
        brand.hidden = !normalize(brand.dataset.lcBrand).includes(query);
        if (!brand.hidden) matches++;
      }
      for (const group of directory.querySelectorAll('[data-lc-brand-group]')) group.hidden = !group.querySelector('[data-lc-brand]:not([hidden])');
      directory.querySelector('[data-lc-brand-empty]').hidden = matches > 0;
    });
    directory.querySelector('[data-lc-brand-controls]').hidden = false;
  }
})();
